import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const wrapper: SxStyle = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const titleSx: SxStyle = {};

export const content: SxStyleFunc<boolean | undefined> = (isProduction) => ({
  p: isProduction ? 'unset' : 3,
});

export const header: SxStyleFunc<boolean | undefined> = (isProduction) => ({
  p: isProduction ? 3 : 2,
  borderBottomWidth: isProduction ? '1px' : 'unset',
  borderBottomStyle: isProduction ? 'solid' : 'unset',
  borderBottomColor: isProduction ? (p) => p.palette.primary[100] : 'unset',
});

export const headerTitle: SxStyle = {
  fontSize: (p) => p.typography.body1.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: (p) => p.palette.primary[400],
};

export const headerIcon: SxStyle = {
  cursor: 'pointer',
};

export const paperProps: SxStyle = {
  width: 1,
  maxWidth: 420,
  minHeight: 1,
  zIndex: 1000,
};
